import { classNames } from "@ember-decorators/component";
import CategoryNotificationsButton from "discourse/select-kit/components/category-notifications-button";
import {
  pluginApiIdentifiers,
  selectKitOptions,
} from "discourse/select-kit/components/select-kit";
import { i18n } from "discourse-i18n";

@pluginApiIdentifiers("circles-notifications-button")
@selectKitOptions({
  i18nPrefix: "discourse_circles.circle.notifications",
  headerAriaLabel: i18n("discourse_circles.circle.notifications.title"),
})
@classNames("circles-notifications-button")
export default class NotificationsButton extends CategoryNotificationsButton {}
